import React from 'react'

import { H2Courses } from '../common/H2/H2'
import {
	SectionCost,
	DivCost,
	TableCost,
	H3Cost,
	CostMeta,
} from '../common/Cost/Cost'

function Tarif() {
	return (
		<SectionCost id="tarifs">
			<DivCost>
				<H2Courses>Tarifs</H2Courses>
				<TableCost>
					<tr>
						<td></td>
						<td>
							<H3Cost>&agrave; l'unit&eacute; (1 heure)</H3Cost>
						</td>
						<td>
							<H3Cost>
								bloc de 5 heures (&agrave; planifier selon les besoins)
							</H3Cost>
						</td>
					</tr>
					<tr>
						<td>
							<H3Cost>Etude (accompagnement pour les devoirs)</H3Cost>
						</td>
						<td>
							<CostMeta>30 euros</CostMeta>
						</td>
						<td>
							<CostMeta>130 euros</CostMeta>
						</td>
					</tr>
					<tr>
						<td>
							<H3Cost>Cours en groupe (maximum 5 &eacute;l&egrave;ves)</H3Cost>
						</td>
						<td>
							<CostMeta>35 euros</CostMeta>
						</td>
						<td>
							<CostMeta>150 euros</CostMeta>
						</td>
					</tr>
					<tr>
						<td>
							<H3Cost>
								Cours particulier (50 % &agrave; d&eacute;duire des
								imp&ocirc;ts)
							</H3Cost>
						</td>
						<td>
							<CostMeta>55 euros</CostMeta>
						</td>
						<td>
							<CostMeta>235 euros</CostMeta>
						</td>
					</tr>
					<tr>
						<td>
							<H3Cost>Stages de révision</H3Cost>
						</td>
						<td colspan="2">
							<CostMeta>selon le nombre d'heures : 30 euros / heure</CostMeta>
						</td>
					</tr>
				</TableCost>
			</DivCost>
		</SectionCost>
	)
}
export default Tarif
